import * as TccReducer from './tccReducer';
import * as TccLisReducer from './listTccReducer';
import * as TccImagesReducer from './imagesTccReducer';
import * as TccSalesReducer from './tccSalesReducer';

const Reducers = {
  ...TccReducer,
  ...TccLisReducer,
  ...TccImagesReducer,
  ...TccSalesReducer,
};

export default Reducers;
